@if (canEdit) {
  <span class="inputNumberEditable">
    <input type="number" [min]="minValue" [max]="maxValue" [step]="1" [(ngModel)]="value" [disabled]="isDisabled" (change)="onNumberValueChange($event)" (keyup)="onNumberValueKeyup($event)" (keydown)="onNumberValueKeydown($event)"/>
    @if (isPercentage) {
      <span>%</span>
    }
  </span>
} @else {
  <span class="readOnlyInputNumber">{{value}}@if (isPercentage) {
    <span>%</span>
  }</span>
}
